import React, { useMemo, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./VisaDetails.css";

const visaData = {
  australia: {
    country: "Australia",
    type: "Tourist/Visit Visa",
    flag: "🇦🇺",
    fee: "18500 BDT",
  },
  belgium: {
    country: "Belgium",
    type: "Tourist/Visit Visa",
    flag: "🇧🇪",
    fee: "12000 BDT",
  },
  cambodia: {
    country: "Cambodia",
    type: "Tourist/Visit Visa",
    flag: "🇰🇭",
    fee: "8000 BDT",
  },
  canada: {
    country: "Canada",
    type: "Tourist/Visit Visa",
    flag: "🇨🇦",
    fee: "15000 BDT",
  },
  china: {
    country: "China",
    type: "Tourist/Visit Visa | Business Visa",
    flag: "🇨🇳",
    fee: "10000 BDT",
  },
  denmark: {
    country: "Denmark",
    type: "Tourist/Visit Visa",
    flag: "🇩🇰",
    fee: "14000 BDT",
  },
  egypt: {
    country: "Egypt",
    type: "Tourist/Visit Visa",
    flag: "🇪🇬",
    fee: "9000 BDT",
  },
  finland: {
    country: "Finland",
    type: "Tourist/Visit Visa",
    flag: "🇫🇮",
    fee: "13000 BDT",
  },
  france: {
    country: "France",
    type: "Tourist/Visit Visa",
    flag: "🇫🇷",
    fee: "16000 BDT",
  },
  germany: {
    country: "Germany",
    type: "Tourist/Visit Visa",
    flag: "🇩🇪",
    fee: "15500 BDT",
  },
  greece: {
    country: "Greece",
    type: "Tourist/Visit Visa",
    flag: "🇬🇷",
    fee: "12500 BDT",
  },
  "hong-kong": {
    country: "Hong Kong",
    type: "Tourist/Visit Visa",
    flag: "🇭🇰",
    fee: "7000 BDT",
  },
  indonesia: {
    country: "Indonesia",
    type: "Tourist/Visit Visa",
    flag: "🇮🇩",
    fee: "6000 BDT",
  },
  italy: {
    country: "Italy",
    type: "Tourist/Visit Visa",
    flag: "🇮🇹",
    fee: "14500 BDT",
  },
  japan: {
    country: "Japan",
    type: "Tourist/Visit Visa",
    flag: "🇯🇵",
    fee: "11000 BDT",
  },
  "new-zealand": {
    country: "New Zealand",
    type: "Tourist/Visit Visa",
    flag: "🇳🇿",
    fee: "17000 BDT",
  },
  pakistan: {
    country: "Pakistan",
    type: "Tourist/Visit Visa",
    flag: "🇵🇰",
    fee: "5000 BDT",
  },
  philippines: {
    country: "Philippines",
    type: "Tourist/Visit Visa",
    flag: "🇵🇭",
    fee: "8500 BDT",
  },
  poland: {
    country: "Poland",
    type: "Tourist/Visit Visa | Business Visa",
    flag: "🇵🇱",
    fee: "11500 BDT",
  },
  portugal: {
    country: "Portugal",
    type: "Tourist/Visit Visa",
    flag: "🇵🇹",
    fee: "13500 BDT",
  },
  qatar: {
    country: "Qatar",
    type: "Tourist/Visit Visa",
    flag: "🇶🇦",
    fee: "9500 BDT",
  },
  "saudi-arabia": {
    country: "Saudi Arabia",
    type: "Umrah Visa",
    flag: "🇸🇦",
    fee: "12000 BDT",
  },
  singapore: {
    country: "Singapore",
    type: "Tourist/Visit Visa | Medical Visa",
    flag: "🇸🇬",
    fee: "10500 BDT",
  },
  "south-korea": {
    country: "South Korea",
    type: "Tourist/Visit Visa",
    flag: "🇰🇷",
    fee: "12500 BDT",
  },
  spain: {
    country: "Spain",
    type: "Tourist/Visit Visa",
    flag: "🇪🇸",
    fee: "15000 BDT",
  },
  "sri-lanka": {
    country: "Sri Lanka",
    type: "Tourist/Visit Visa",
    flag: "🇱🇰",
    fee: "4500 BDT",
  },
  sweden: {
    country: "Sweden",
    type: "Tourist/Visit Visa",
    flag: "🇸🇪",
    fee: "14000 BDT",
  },
  switzerland: {
    country: "Switzerland",
    type: "Tourist/Visit Visa",
    flag: "🇨🇭",
    fee: "16500 BDT",
  },
  tanzania: {
    country: "Tanzania",
    type: "Tourist/Visit Visa",
    flag: "🇹🇿",
    fee: "8000 BDT",
  },
  thailand: {
    country: "Thailand",
    type: "Tourist/Visit Visa | Medical Visa",
    flag: "🇹🇭",
    fee: "7500 BDT",
  },
  turkey: {
    country: "Turkey",
    type: "Tourist/Visit Visa",
    flag: "🇹🇷",
    fee: "9000 BDT",
  },
};

const VisaDetails = () => {
  const { country } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [country]);

  const visa = useMemo(() => {
    const countryData = visaData[country];

    return {
      country:
        countryData?.country ||
        country?.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()) ||
        "Country",
      type: countryData?.type || "Tourist/Visit Visa",
      flag: countryData?.flag || "🌍",
      fee: countryData?.fee || "Contact for details",
      processingTime: "7-15 working days (Depending on file numbers)",
      validity: "1 - 3 Years",
      eligibility: [
        "Valid passport with minimum 6 months validity.",
        "Good travel history and financial profile.",
      ],
      documents: [
        "Original Passport with minimum 6 months validity",
        "Visa Application Form",
        "Recent passport size photographs",
        "Covering Letter from applicant",
        "Bank statements and financial documents",
        "Travel itinerary and hotel bookings",
        "Employment certificate or business documents",
      ],
    };
  }, [country]);

  return (
    <>
      {/* Header */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-2"
          style={{ maxWidth: "900px" }}
        >
          <h3
            className="text-white display-3 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Visa Details
          </h3>
        </div>
      </div>

      {/* Title Section */}
      <div className="container-fluid py-3">
        <div className="container">
          <div className="row mb-4 wow fadeInUp" data-wow-delay="0.1s">
            <div className="col-12">
              <div className="d-flex align-items-center justify-content-between">
                <h1 className="display-4 mb-0">
                  {visa.country} - {visa.type}
                </h1>
                <span className="flag-large">{visa.flag}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Visa Details Content */}
      <div className="container-fluid py-2">
        <div className="container">
          {/* Info Cards */}
          <div className="row g-4 mb-4">
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
              <div className="info-card text-center p-4">
                <div className="info-icon mb-3">
                  <i className="fas fa-money-bill-wave fa-3x text-primary"></i>
                </div>
                <h5 className="mb-2">Visa Fee</h5>
                <p className="text-primary fw-bold">{visa.fee}</p>
              </div>
            </div>
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
              <div className="info-card text-center p-4">
                <div className="info-icon mb-3">
                  <i className="fas fa-clock fa-3x text-primary"></i>
                </div>
                <h5 className="mb-2">Processing Time</h5>
                <p className="text-muted">{visa.processingTime}</p>
              </div>
            </div>
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.4s">
              <div className="info-card text-center p-4">
                <div className="info-icon mb-3">
                  <i className="fas fa-calendar-check fa-3x text-primary"></i>
                </div>
                <h5 className="mb-2">Visa Validity</h5>
                <p className="text-muted">{visa.validity}</p>
              </div>
            </div>
          </div>

          {/* Eligibility Section */}
          <div className="row mb-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="col-12">
              <div className="section-card p-4">
                <h3 className="section-title mb-4">Eligibility</h3>
                <ul className="eligibility-list">
                  {visa.eligibility.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Required Documents Section */}
          <div className="row mb-4 wow fadeInUp" data-wow-delay="0.6s">
            <div className="col-12">
              <div className="section-card p-4">
                <h3 className="section-title mb-4">Required Documents</h3>
                <ul className="documents-list">
                  {visa.documents.map((doc, index) => (
                    <li key={index}>{doc}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="row mb-4 wow fadeInUp" data-wow-delay="0.7s">
            <div className="col-12">
              <div className="disclaimer-card p-4">
                <p className="mb-0">
                  <strong>Please note:</strong> All expenditures related to visa
                  processing are strictly non-refundable. Visa information and
                  associated charges are subject to change at any time without
                  prior notice. We provide assistance only and do not guarantee
                  the issuance of visas. This information sheet has been
                  prepared by us and may include additional details beyond the
                  embassy's requirements. The total approximate processing time
                  is 30-60 days (Time may vary depending on the applicant's
                  profile and the embassy's actual processing time)
                </p>
              </div>
            </div>
          </div>

          {/* How to Apply Section */}
          <div className="row wow  mb-4 fadeInUp" data-wow-delay="0.8s">
            <div className="col-12">
              <div className="apply-section p-5">
                <div className="row align-items-center">
                  <div className="col-lg-8">
                    <h3 className="mb-3">How to Apply</h3>
                    <p className="mb-0">Need assistance in visa application?</p>
                  </div>
                  <div className="col-lg-4 text-end">
                    <a
                      href="tel:+8801852966938"
                      className="btn btn-primary btn-lg"
                    >
                      Call us at +8801852966938
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VisaDetails;
